import React from 'react';
import { Router, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from '../_helpers';
import postLogin from '../_helpers/postLogin';
import { alertActions } from '../_actions';
import { PrivateRoute } from '../_components/PrivateRoute';
import { RoleRoute } from '../_components/RoleRoute';
import { LoginPage } from '../LoginPage';
import { AdminPage } from '../AdminPage';
import { RegisterPage } from '../RegisterPage';
import { RegisterPage2 } from '../RegisterPage2';
import DeletePage from '../DeletePage/DeletePage';
import VotePage from '../VotePage/VotePage';
import { ResultsPage } from '../ResultsPage';
import { DeleteAllAnswersConfirmPage } from '../DeleteAllAnswersConfirmPage';
import Header from '../components/Header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactTooltip from 'react-tooltip';
import NoAccess from '../NoAccess';
import { store } from "../_helpers/store";
import { userConstants } from '../_constants';
import FeatureDisabled from '../FeatureDisabled';
import { ROLES } from "../_constants/roles";
import {PollFreezeCard} from '../PollManagement/Components/PollFreezeCard'
    
let container;

class App extends React.Component {
    constructor(props) {
        super(props);

        const { dispatch } = this.props;
        history.listen((location, action) => {
            dispatch(alertActions.clear());
        });
    }

    setCurrentUser = (user) => {
        try {
            localStorage.setItem("user", JSON.stringify(user));
            store.dispatch({ type: userConstants.LOGIN_SUCCESS, user });
        } catch (e) {
            console.log("Failed to set current user:", e);
        }
    }

    async componentDidMount() {
        postLogin()
            .then(user => {
                const isJudge = user.roles.includes(ROLES.JUDGE);
                const isAdmin = user.roles.includes(ROLES.ADMIN);

                if (!isAdmin && !isJudge) {
                    history.push("/no-access");
                    return;
                }
                    
                this.setCurrentUser(user);

                history.push(isJudge ? "/vote" : "/results");                

            }).catch(() => {
            })
    }

    render() {
        const { alert } = this.props;

        return (
            <div>
                <div id="state-indicator"></div>

                <ToastContainer
                    position="bottom-center"
                    hideProgressBar={true}
                />
                <div id="main">

                    <ReactTooltip />

                    <div id="header">
                        <Header />
                    </div>

                    <div id="main-page">
                        <div id="page">

                            {alert.message &&
                                <div class={`alert ${alert.type}`}>{alert.message}</div>
                            }

                            <div>
                                <RoleRoute exact path="" />
                                <PrivateRoute exact path="/vote" component={VotePage} />
                                <PrivateRoute path="/vote/:judgeId" component={VotePage} />
                                <PrivateRoute path="/results" component={ResultsPage} />
                                <PrivateRoute path="/reset" component={ResultsPage} action='reset' />
                                <Route path="/login" component={LoginPage} />
                                <Route path="/admin" component={AdminPage} />
                                <Route path="/register" component={RegisterPage} />
                                <Route path="/register2" component={RegisterPage2} />
                                <Route path="/delete" component={DeletePage} />
                                <Route path="/no-access" component={NoAccess} />
                                <Route path="/feature-disabled" component={FeatureDisabled} />
                                <Route path="/deleteallanswersconfirm" component={DeleteAllAnswersConfirmPage} />    
                                <Route path="/pollfreeze" component={PollFreezeCard}/>                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert
    };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App }; 